import { UserInteface, UserState } from '../../models/state';
import { actionTypes } from '../actions/user';

const initialState: UserState = {
  user: {} as UserInteface,
  users: [],
  userCount: 0,
};
const userReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.GET_USERS_SUCCESS: {
      return {
        ...state,
        users: action.payload.rows,
        userCount: action.payload.count,
      };
    }
    default: {
      return state;
    }
  }
};

export default userReducer;
